import { useNotifications } from "@relode/core";
import * as React from "react";

import { CandidateState } from "./candidateState";
import { FeatureActions } from "./combinedCandidatesFeatureActions";

export const useCandidateErrorHandlers = (
    state: CandidateState,
    actions: FeatureActions
) => {
    const { actions: notifications } = useNotifications();
    const {
        ui: { error },
    } = state;

    React.useEffect(() => {
        if (!error) return; // we don't close from here.  might be odd

        const message =
            error.message ??
            error.apiError?.friendlyMessages ??
            "we've encountered a problem";

        switch (error.type) {
            case "loading": {
                notifications.showArea("error", message, "loadCandidate", {
                    canClose: false,
                });
                break;
            }
            case "updateFeedback": {
                notifications.showSnack("error", "feedback not saved");
                break;
            }
            default: {
                if (error.apiError.summary) {
                    notifications.showModal("error", "we're sorry", message, {
                        callback: () => {
                            actions.clearError();
                        },
                    });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
};
